<template>
    <b-row class="ml-1">
        <b-col cols="12">
            <h3>Renovacion automática</h3> 
        </b-col>
        <b-col cols="12">
            <p class="mb-2">El siguiente check, si está marcado, se le renovará automáticamente el abono al inicio de la siguiente temporada.</p>
            <p class="mt-0">El cobro del importe del abono se le hará a la tarjeta de crédito asociada al usuario.</p>
        </b-col>
        <b-col cols="12">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="renovacion_automatica" v-model="checked" :disabled="!checked" @change="showModal()" />
                <label for="renovacion_automatica" class="custom-control-label">
                    <small>* En caso de desmarcar esta casilla, <b style="font-size: 15px;">NO SE PODRÁ VOLVER A MARCAR.</b></small>
                </label>
            </div>
        </b-col>
        <ModalComponent
            name="confirmar-renovacion-automatica"
            title="Desactivar renovación automática"
            @close="closeModal()"
        >
            <h3>¿Estás seguro de desactivar la renovación automática de este abono en la siguiente temporada?</h3>
            <h4><b>*ESTE CAMBIO NO SE PODRÁ DESHACER</b></h4>
            <Button class="mt-2 mr-2" @click="confirmar()">ACEPTAR</Button>
            <Button class="mt-2" @click="closeModal()">CANCELAR</Button>
        </ModalComponent>
    </b-row>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: {
            abonado: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                checked: this.abonado.renovacion_automatica
            }
        },
        methods: {
            confirmar() {
                this.$emit('updateAbonado');
            },
            showModal() {
                this.$modal.show('confirmar-renovacion-automatica');
            },
            closeModal() {
                this.checked = 1;
                this.$modal.hide('confirmar-renovacion-automatica');
            }
        },
        components: {
            ModalComponent
        }
    }
</script>